// HomePage.tsx
"use client"

import { Suspense, useEffect, useState } from "react"

// In theory shouldn't be needed but builds break without it.
// Introduced with support for i18n
export const runtime = "edge"

export default function HomePage() {
  const [location, setLocation] = useState("")
  const [queryParams, setQueryParams] = useState([])

  useEffect(() => {
    setLocation(window.location.href)
    const params = new URLSearchParams(window.location.search)
    const paramsArray = []
    for (const [key, value] of params.entries()) {
      paramsArray.push(`${key}: ${value}`)
    }
    setQueryParams(paramsArray)
  }, [])

  return (
    <>
      <Suspense fallback={<p>Loading...</p>}>
        <p>
          <strong>Current Location:</strong>
        </p>
        <p>{location}</p>
        <br />
        <p>
          <strong>Query Parameters:</strong>
        </p>
        <ul>
          {queryParams.map((param, index) => (
            <li key={index}>{param}</li>
          ))}
        </ul>
      </Suspense>
    </>
  )
}
